import * as form from '../form';

export const substanceDrugOrdered = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        OrderedBy: form.checkboxgroup(xitem.OrderedBy),
        Explanation: form.textarea(xitem.Explanation),
        ActionTaken: form.branch(xitem.ActionTaken),
        NoActionTakenExplanation: form.textarea(xitem.NoActionTakenExplanation),
        DrugType: form.radio(xitem.DrugType),
        TreatmentProvider: form.name(xitem.TreatmentProvider),
        TreatmentProviderNotApplicable: form.notapplicable(xitem.TreatmentProviderNotApplicable),
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        TreatmentProviderTelephone: form.telephone(xitem.TreatmentProviderTelephone),
        TreatmentDates: form.daterange(xitem.TreatmentDates),
        TreatmentCompleted: form.branch(xitem.TreatmentCompleted),
        NoTreatmentExplanation: form.textarea(xitem.NoTreatmentExplanation),
        OrderedByComments: form.textarea(xitem.OrderedByComments),
        NoActionTakenComments: form.textarea(xitem.NoActionTakenComments),
        Comments: form.textarea(xitem.Comments),
        NoTreatmentComments: form.textarea(xitem.NoTreatmentComments),
        DueToDrugs: form.branch(xitem.DueToDrugs),
        DrugTypes: form.checkboxgroup(xitem.DrugTypes),
        DrugTypeOther: form.textarea(xitem.DrugTypeOther),
        DueToPrescription: form.branch(xitem.DueToPrescription),
        PrescriptionDrug: form.text(xitem.PrescriptionDrug),
        TreatmentProviderInPractice: form.branch(xitem.TreatmentProviderInPractice),
        TreatmentProviderTelephones: form.collection(form.telephoneCollection(xitem.TreatmentProviderTelephones)),
        TreatmentProviderEmails: form.collection(form.emailCollection(xitem.TreatmentProviderEmails)),
        TreatmentProviderPracticeName: form.text(xitem.TreatmentProviderPracticeName),
        TreatmentProviderPracticeNameNotApplicable: form.notapplicable(xitem.TreatmentProviderPracticeNameNotApplicable),
        TreatmentStatus: form.textarea(xitem.TreatmentStatus),
        OrderedBySingle: form.radio(xitem.OrderedBySingle),
        OrderedBySingleOther: form.textarea(xitem.OrderedBySingleOther),
      },
    };
  });
  return {
    TreatmentOrdered: form.branch(data.TreatmentOrdered),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
